import React from "react";

function Cateringpackagesorders() {
    // Sample lead data (replace with API later)
    const enquiryList = [
        {
            id: 1,
            promisedLeads: 100,
            consumedLeads: 80,
            balancedLeads: 20,
            startDate: "2025-09-01",
            endDate: "2025-09-30",
            status: "Active",
        },
        {
            id: 2,
            promisedLeads: 50,
            consumedLeads: 50,
            balancedLeads: 0,
            startDate: "2025-08-01",
            endDate: "2025-08-31",
            status: "Completed",
        },
        {
            id: 3,
            promisedLeads: 75,
            consumedLeads: 30,
            balancedLeads: 45,
            startDate: "2025-09-10",
            endDate: "2025-09-25",
            status: "In Progress",
        },
    ];

    return (
        <div style={{ marginLeft: "-10px" }}>
            <table
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginTop: "15px",
                    fontSize: "16px",
                }}
            >
                <thead>
                    <tr style={{ backgroundColor: "rgb(177 93 198)", color: "white" }}>
                        <th style={{ backgroundColor: "rgb(177 93 198)", color: "#fff" }}>User ID</th>
                        <th style={{ backgroundColor: "rgb(177 93 198)", color: "#fff" }}>Name</th>
                        <th style={{ backgroundColor: "rgb(177 93 198)", color: "#fff" }}>Email Id</th>
                        <th style={{ backgroundColor: "rgb(177 93 198)", color: "#fff" }}>Mobile Number</th>
                        <th style={{ backgroundColor: "rgb(177 93 198)", color: "#fff" }}>Location</th>
                        <th style={{ backgroundColor: "rgb(177 93 198)", color: "#fff" }}>Package Type</th>
                        <th style={{ backgroundColor: "rgb(177 93 198)", color: "#fff" }}>Event Type</th>
                        <th style={{ backgroundColor: "rgb(177 93 198)", color: "#fff" }}>Price</th>
                        <th style={{ backgroundColor: "rgb(177 93 198)", color: "#fff" }}>Plates</th>
                        <th style={{ backgroundColor: "rgb(177 93 198)", color: "#fff" }}>Total Price</th>
                    </tr>
                </thead>
                <tbody>
                    {enquiryList.map((item) => (
                        <tr key={item.id}>
                            <td style={tdStyle}>#0001</td>
                            <td style={tdStyle}>Harish</td>
                            <td style={tdStyle}>harish123@gmail.com</td>
                            <td style={tdStyle}>8456215474</td>
                            <td style={tdStyle}>Kphb</td>
                            <td style={tdStyle}>Veg meals</td>
                            <td style={tdStyle}>Birthday</td>
                            <td style={tdStyle}>150</td>
                            <td style={tdStyle}>20</td>
                            <td style={tdStyle}>3000</td>
                            {/* <td style={tdStyle}>{item.endDate}</td> */}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

// Inline styles
const thStyle = {
    border: "1px solid #ccc",
    padding: "10px",
    textAlign: "left",
    fontWeight: "bold",
};

const tdStyle = {
    border: "1px solid #ccc",
    padding: "10px",
};

export default Cateringpackagesorders;
